import { useState, useEffect } from 'react'
import { designService } from '../services/api'
import ImageBrowser from './ImageBrowser'
import LoadingSpinner from './LoadingSpinner'

export default function ManualInput({ onDesignCreated }) {
  const [templateType, setTemplateType] = useState('single')
  const [showImageBrowser, setShowImageBrowser] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [item1, setItem1] = useState({
    name: '',
    quantity: '',
    price: '',
    image_filename: ''
  })

  const [item2, setItem2] = useState({
    name: '',
    quantity: '',
    price: '',
    image_filename: ''
  })

  const handleImageSelect = (image) => {
    if (showImageBrowser === 'item1') {
      setItem1({ ...item1, image_filename: image.filename })
    } else if (showImageBrowser === 'item2') {
      setItem2({ ...item2, image_filename: image.filename })
    }
    setShowImageBrowser(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!item1.name || !item1.quantity || !item1.price || !item1.image_filename) {
      setError('Please fill all item 1 fields')
      return
    }

    if (templateType === 'double' && (!item2.name || !item2.quantity || !item2.price || !item2.image_filename)) {
      setError('Please fill all item 2 fields for double template')
      return
    }

    try {
      setLoading(true)
      const response = await designService.renderDesign(
        templateType,
        item1,
        templateType === 'double' ? item2 : null
      )

      if (response.data.success) {
        onDesignCreated(response.data.data)
        setError(null)
      } else {
        setError(response.data.message || 'Failed to render design')
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Error rendering design')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  if (showImageBrowser) {
    return (
      <ImageBrowser
        onSelect={handleImageSelect}
        onBack={() => setShowImageBrowser(null)}
      />
    )
  }

  if (loading) return <LoadingSpinner />

  return (
    <div className="manual-input">
      <h2>Create Design</h2>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit} className="form">
        <div className="form-section">
          <label>Template Type</label>
          <div className="radio-group">
            <label>
              <input
                type="radio"
                value="single"
                checked={templateType === 'single'}
                onChange={(e) => setTemplateType(e.target.value)}
              />
              Single Item
            </label>
            <label>
              <input
                type="radio"
                value="double"
                checked={templateType === 'double'}
                onChange={(e) => setTemplateType(e.target.value)}
              />
              Double Item
            </label>
          </div>
        </div>

        <div className="form-section">
          <h3>Item 1</h3>
          <input
            type="text"
            placeholder="Product Name"
            value={item1.name}
            onChange={(e) => setItem1({ ...item1, name: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Quantity (e.g., for 100g)"
            value={item1.quantity}
            onChange={(e) => setItem1({ ...item1, quantity: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Price"
            value={item1.price}
            onChange={(e) => setItem1({ ...item1, price: e.target.value })}
            required
          />
          <button
            type="button"
            className="image-btn"
            onClick={() => setShowImageBrowser('item1')}
          >
            {item1.image_filename ? `✓ ${item1.image_filename}` : 'Select Image'}
          </button>
        </div>

        {templateType === 'double' && (
          <div className="form-section">
            <h3>Item 2</h3>
            <input
              type="text"
              placeholder="Product Name"
              value={item2.name}
              onChange={(e) => setItem2({ ...item2, name: e.target.value })}
            />
            <input
              type="text"
              placeholder="Quantity (e.g., for 100g)"
              value={item2.quantity}
              onChange={(e) => setItem2({ ...item2, quantity: e.target.value })}
            />
            <input
              type="text"
              placeholder="Price"
              value={item2.price}
              onChange={(e) => setItem2({ ...item2, price: e.target.value })}
            />
            <button
              type="button"
              className="image-btn"
              onClick={() => setShowImageBrowser('item2')}
            >
              {item2.image_filename ? `✓ ${item2.image_filename}` : 'Select Image'}
            </button>
          </div>
        )}

        <button type="submit" className="submit-btn">
          Create Design
        </button>
      </form>
    </div>
  )
}
